<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title"><span class="bold">Victoria Crosses on the Western Front Second Battle of Bapaume</span></h1>
<p class="titlea"><span class="bold">August–September 1918</span></p>
<p class="author"><span class="bold">Paul Oldfield</span></p>
<div class="image_containerf">
<img alt="images" src="images/f0iii-01.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?1a9e8b4b